import { render, staticRenderFns } from "./update-saler.vue?vue&type=template&id=40f88ea0&scoped=true&"
import script from "./update-saler.vue?vue&type=script&lang=js&"
export * from "./update-saler.vue?vue&type=script&lang=js&"
import style0 from "./update-saler.vue?vue&type=style&index=0&id=40f88ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f88ea0",
  null
  
)

export default component.exports